import { initCopyPlainText } from "./Clipboard.ts";
import { initBasicDragDrop } from "./DragDropUpload.ts";
import {
  addConditionalHideFeatureToOverlayPanel,
  addNoCacheFeatureToSelectOneMenu,
  catchErrorsExtSheet,
  fixMenuPositioning,
  fixPasswordForCustomStrengthCheck,
  fixWcagMenu,
  fixWcagMenuButton,
  fixWcagSelectCheckboxMenu,
  fixWcagSelectOneMenu,
  fixWcagSplitButton,
  showFileUploadMessagesAsGrowl,
} from "./Fixes.ts";
import { FormTracker } from "./FormTracker.ts";
import { initPageExitPrompt } from "./Navigation.ts";
import { keepGrowlMessagesOnHover, keepTooltipMessageOnHover } from "./Notification.ts";
import { initSearch } from "./Search.ts";
import { initWindowManager } from "./WindowManager.ts";

/**
 * Setup on document ready that needs to be done for every backend page.
 */
export function OnDocumentReady(): void {
  // Attach delegate listener for search fields.
  initSearch();

  // Fix growl messages disappearing on focus/hover.
  keepGrowlMessagesOnHover();

  // Keep tooltips on hover.
  keepTooltipMessageOnHover();

  // Prevent errors in the PrimeFaces extension data sheet from blocking other
  // JavaScript code.
  catchErrorsExtSheet();

  // Show error messages from file uploads as a global growl message (as they
  // are drag&drop now)
  showFileUploadMessagesAsGrowl();

  // Add a "cache" option to the `<p:selectOneMenu />` component to disable
  // caching the select options and reload them every time the panel is opened.
  addNoCacheFeatureToSelectOneMenu();

  addConditionalHideFeatureToOverlayPanel();

  // Fix the positioning of p:menu menus.
  fixMenuPositioning();

  // Accessibility
  fixWcagSelectOneMenu();
  fixWcagSelectCheckboxMenu();
  fixWcagMenuButton();
  fixWcagMenu();
  fixWcagSplitButton();

  // Get current form data, to inform user about unsaved changes.
  FormTracker.getInstance().onDocumentReady();

  // Attach listener to beforeunload to prompt the user when they attempt to
  // close the page.
  initPageExitPrompt();

  // Copy text as plain text instead of the HTML markup
  initCopyPlainText();

  // Allow for custom password strength checks
  fixPasswordForCustomStrengthCheck();

  initWindowManager();

  initBasicDragDrop();
}
